<his-plam
    [label]="setting().label | hisUi"
    [helptext]="setting().helptext | hisUi"
    [required]="setting().required"
    [title]="title()">
    <p-calendar
        #content
        [(ngModel)]="value"
        dateFormat="dd.mm.yy"
        [showIcon]="true"
        [disabled]="setting().readonly"
        [minDate]="minValue()"
        [maxDate]="maxValue()"
    />
</his-plam>
